<template>
  <footer class="bg-gray-900 text-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
        <!-- Brand -->
        <div>
          <h3 class="text-2xl font-bold mb-4">💍 Banjara</h3>
          <p class="text-gray-400">Find your perfect match on India's trusted matrimonial platform.</p>
        </div>

        <!-- Quick Links -->
        <div>
          <h4 class="font-bold mb-4">Quick Links</h4>
          <ul class="space-y-2 text-gray-400">
            <li><a href="/" class="hover:text-white transition">Home</a></li>
            <li><a href="/browse" class="hover:text-white transition">Browse Profiles</a></li>
            <li><a href="/about" class="hover:text-white transition">About Us</a></li>
            <li><a href="/contact" class="hover:text-white transition">Contact</a></li>
          </ul>
        </div>

        <!-- Services -->
        <div>
          <h4 class="font-bold mb-4">Services</h4>
          <ul class="space-y-2 text-gray-400">
            <li><a href="#" class="hover:text-white transition">Premium Membership</a></li>
            <li><a href="#" class="hover:text-white transition">Verified Profiles</a></li>
            <li><a href="#" class="hover:text-white transition">Video Call</a></li>
            <li><a href="#" class="hover:text-white transition">Success Stories</a></li>
          </ul>
        </div>

        <!-- Contact -->
        <div>
          <h4 class="font-bold mb-4">Contact</h4>
          <ul class="space-y-2 text-gray-400">
            <li>Email: info@banjara.com</li>
            <li>Phone: +91 9876543210</li>
            <li>Address: India</li>
          </ul>
        </div>
      </div>

      <div class="border-t border-gray-800 pt-8">
        <p class="text-center text-gray-400">&copy; 2026 Banjara Matrimonial. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
// Footer component
</script>
